import { faChevronLeft } from '@fortawesome/pro-light-svg-icons';

import './ChevronBackBtn.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

type ChevronBackBtnProps = {
  className?: string;
  onClick: () => void;
};

function ChevronBackBtn({ className, onClick }: ChevronBackBtnProps) {
  const { t } = useTranslation();

  return (
    <button type="button" className={`chevronBackBtn ${className}`} onClick={onClick}>
      <FontAwesomeIcon icon={faChevronLeft} className="icon" />
      <span className="visuallyHidden">{t('M011')}</span>
    </button>
  );
}

export default ChevronBackBtn;
